import React from 'react';

const PX_PER_MIN = 1.6;
const toMin = (t) => {
  const [h, m] = (t || '0:0').split(':').map(Number);
  return h * 60 + m;
};
const pad = (n) => String(n).padStart(2, '0');

// Grille hebdomadaire positionnée en minutes : un créneau de 30 min reste lisible
export const WeekTimeGrid = ({ days, slots, renderSlot }) => {
  const starts = slots.map((s) => toMin(s.start_time));
  const ends = slots.map((s) => toMin(s.end_time));
  const dayStart = Math.min(8 * 60, ...starts.map((m) => Math.floor(m / 60) * 60));
  const dayEnd = Math.max(17 * 60, ...ends.map((m) => Math.ceil(m / 60) * 60));
  const height = (dayEnd - dayStart) * PX_PER_MIN;
  const hours = [];
  for (let m = dayStart; m <= dayEnd; m += 60) hours.push(m);
  const visibleDays = days.filter((d) => d.value < 5 || slots.some((s) => s.day_of_week === d.value));

  return (
    <div className="overflow-x-auto" data-testid="week-time-grid">
      <div className="grid min-w-[760px]" style={{ gridTemplateColumns: `64px repeat(${visibleDays.length}, minmax(120px, 1fr))` }}>
        <div />
        {visibleDays.map((d) => (
          <div key={d.value} className="text-center text-sm font-medium py-2 border-b">{d.short}</div>
        ))}
        <div className="relative" style={{ height }}>
          {hours.map((m) => (
            <div key={m} className="absolute right-2 text-xs text-gray-500 -translate-y-2" style={{ top: (m - dayStart) * PX_PER_MIN }}>
              {pad(Math.floor(m / 60))}:00
            </div>
          ))}
        </div>
        {visibleDays.map((d) => (
          <div key={d.value} className="relative border-l border-gray-200" style={{ height }}>
            {hours.map((m) => (
              <div key={m} className="absolute inset-x-0 border-t border-gray-100" style={{ top: (m - dayStart) * PX_PER_MIN }} />
            ))}
            {slots.filter((s) => s.day_of_week === d.value).map((s) => {
              const top = (toMin(s.start_time) - dayStart) * PX_PER_MIN;
              const h = Math.max(toMin(s.end_time) - toMin(s.start_time), 20) * PX_PER_MIN;
              return (
                <div key={s.id} data-testid={`grid-slot-${s.id}`} className="absolute inset-x-1 overflow-hidden rounded-md border border-blue-200 bg-blue-50 px-1.5 py-1"
                  style={{ top, height: h - 2 }}>
                  {renderSlot(s, h)}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
